import React from "react";
import {Dropdown, OverlayTrigger, Tooltip} from "react-bootstrap";
import {useTranslate} from "@tolgee/react";
import {UPGRADE_SUBSCRIPTION_URL} from "../../../../config/constants";

interface UpgradeRequiredTooltipProps {
    show: boolean;
    children: React.ReactElement;
}

const UpgradeRequiredTooltipWrapper: React.FC<UpgradeRequiredTooltipProps> = ({ show, children }) => {
    const { t } = useTranslate();

    return (
        <OverlayTrigger
            delay={{ show: 10, hide: 1000 }}
            placement="auto"
            overlay={
                show ? ( // Show tooltip only if disabled
                    <Tooltip id={`tooltip-`}>
                        <div>
                            {t(
                                "lomavisCreator.multipostSettings.featureNotAvailable"
                            )}
                        </div>

                        <div className="w-100 mt-2 text-end">
                            <a
                                href={UPGRADE_SUBSCRIPTION_URL}
                                target="_blank"
                                className="text-nowrap"
                            >
                                {t("lomavisCreator.multipostSettings.upgradeNow")}
                            </a>
                        </div>
                    </Tooltip>
                ) : (
                    <></>
                )
            }
        >
            {children}

        </OverlayTrigger>
    );
};

export default UpgradeRequiredTooltipWrapper;
